var React = require('react');

function ChevronRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M5 1L8 4L11 1","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","shapeRendering":"crispEdges"}));
}

ChevronRight.defaultProps = {"width":"16","height":"13","viewBox":"0 -3 16 12","transform":"rotate(-90.1)"};

module.exports = ChevronRight;

ChevronRight.default = ChevronRight;
